enum OnlineStatus {
  Offline = 'Offline',
  Online = 'Online',
  InSession = 'InSession'
}

export default OnlineStatus;
